import React, { useCallback, useEffect } from 'react';
import Header from '../../components/Header/Header';
import createDOMPurify from 'dompurify';
import useGetPageConfig from '../../hooks/useGetPageConfig';
import PrivacyPolicyMovioEN from './translations/en/PrivacyPolicy.html';
import PrivacyPolicyZvaigzdeplayEN from './translations/en/privacyPolicyZvaigzdeplay.html';
import PrivacyPolicyMobiotvEN from './translations/en/privacyPolicyMobiotv.html';
import PrivacyPolicyID from './translations/id/PrivacyPolicyID.html';
import PrivacyPolicyNonton from './translations/en/privacyPolicy_nonton.html';
import PrivacyPolicyBG from './translations/bg/PrivacyPolicy_bg.html';

import { config, getHostname } from '../../constants/domainConfig';
import PageLoader from '../../components/Loaders/PageLoader';
import { dashboardURL } from '../../constants/dashboardURL';

const sanitize = (html) => {
    if (!window) return '';
    return createDOMPurify(window).sanitize(html);
};

const getPrivacyPolicyTranslated = (product) => {
    console.log('product', product, config.country);
    switch (product) {
        case 'zvaigzdeplay':
        case 'zlataplay':
            return PrivacyPolicyZvaigzdeplayEN;
        case 'mobiotv':
            return PrivacyPolicyMobiotvEN;
        case 'nonton-tv':
            if (config.lang === 'id') {
                return PrivacyPolicyID;
            }
            return PrivacyPolicyNonton;
        case 'playnixzone':
            if (config.lang === 'bg') {
                return PrivacyPolicyBG;
            }
            return PrivacyPolicyMovioEN;
        default:
            return PrivacyPolicyMovioEN;
    }
};

const PrivacyPolicy = () => {
    const [loading, setLoading] = React.useState(false);
    const [html, setHTML] = React.useState('');
    const { product } = useGetPageConfig();

    const fetchHTML = useCallback(
        async (url) => {
            setLoading(true);
            try {
                const response = await fetch(url);
                if (response.ok) {
                    const html = await response.text();
                    setHTML(html);
                } else {
                    console.warn(`Failed to fetch external FAQ from ${url} (status: ${response.status}). Falling back to local version.`);
                    setHTML(getPrivacyPolicyTranslated(product)); // Fallback to local version if fetch fails
                }
            } catch (error) {
                console.error(`Error fetching external FAQ from ${url}:`, error);
                setHTML(getPrivacyPolicyTranslated(product)); // Fallback to local version if fetch fails
            } finally {
                setLoading(false);
            }
        },
        [product],
    );

    useEffect(() => {
        const url = new URL(dashboardURL);
        url.searchParams.append('pageType', 'privacy-policy');
        url.searchParams.append('subdomain', getHostname());
        url.searchParams.append('language', 'en'); // Only English is available as of now
        fetchHTML(url);
    }, [fetchHTML, product]);

    if (loading) return <PageLoader />;

    return (
        <>
            <Header forceHideHamburger />
            <div className="static-pages">
                <div dangerouslySetInnerHTML={{ __html: sanitize(html) }} />
            </div>
        </>
    );
};

export default PrivacyPolicy;
